/**
 * Nova AI chat interface color definitions
 */
import { palette, createColor } from './palette.colors';

export const novaAIColors = {
  BGColor: createColor(palette.gray.white, palette.dark.content),
  shadowColor: createColor(palette.special.shadowLight, palette.special.shadow),
  AIShadowColor: createColor(palette.special.shadow, palette.special.shadow),
  borderColor: createColor(palette.gray.border, palette.dark.borderLight),
  userMessageBGColor: createColor(palette.blue.primary, palette.blue.primary),
  userMessageColor: createColor(palette.gray.white, palette.gray.white),
  userMessageBorder: createColor(palette.gray.borderMedium, palette.gray.borderMedium),
  userMessageText: createColor(palette.gray.white, palette.gray.white),
  botMessageBGColor: createColor(palette.gray.white, palette.dark.cardDark),
  botMessageColor: createColor(palette.gray.black, palette.gray.black),
  botMessageBorder: createColor(palette.gray.borderMedium, palette.dark.techBorder),
  botMessageText: createColor(palette.gray.darkest, palette.dark.textAlt),
  searchTextInputTopBorderColor: createColor(palette.gray.borderMedium, palette.dark.techBorder),
  inputTextColor: createColor(palette.gray.black, palette.dark.textAlt),
  inputTextBorderColor: createColor(palette.gray.borderMedium, palette.dark.techBorder),
  footerTextColor: createColor(palette.gray.darker, palette.gray.darker),
  botIconBGColor: createColor(palette.blue.tint, palette.blue.tint),
  contextText: createColor(palette.blue.onTint, palette.dark.textAlt),
  contextSubText: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  iconBGColor: createColor(palette.blue.secondary, palette.blue.secondary),
  cardBorderColor: createColor(palette.gray.divider, palette.dark.techBorder),
  cardTextColor: createColor(palette.blue.onTint, palette.dark.textAlt),
  cardExampleTextColor: createColor(palette.gray.lightDarkGrey, palette.dark.textAlt),
  voiceIconGreyColor: createColor(palette.gray.darkest, palette.gray.darkest),
  voiceIconBlueColor: createColor(palette.gray.white, palette.gray.white),
  voiceIconGreyFillColor: createColor(palette.gray.bottomGreyBorder, palette.gray.bottomGreyBorder),
  voiceIconBlueFillColor: createColor(palette.blue.primary, palette.blue.primary),
  waveformBarColor: createColor(palette.opacity.novaVoiceBase, palette.opacity.novaVoiceBase),
  volumeIconColor: createColor(palette.gray.darkest, palette.dark.textAlt),
};